import React, {useEffect, useRef, useState} from 'react'
import styled from 'styled-components'
import P from '../../commons/P'
import H1 from '../../commons/H1'
import imgSource from '../../../img/ico_check_brand.svg'
import Header from "../../commons/Header";
import Footer from "../../commons/footer/Footer";
import bgUrl from '../../../img/bg_intro.jpg'
import PreventivatoreTitleSection from "../../preventivatoreCommons/TitleSection";
import publicHeaderBackground from '../../../img/PREVENTIVATORE_PUBBLICO.jpg'
import privateHeaderBackground from '../../../img/PREVENTIVATORE_PRIVATO.jpg'
import retiredHeaderBackground from '../../../img/PREVENTIVATORE_PENSIONATO.jpg'
import defaultHeaderBackground from "../../../img/PREVENTIVATORE_NEUTRO.jpg";
import defaultMobileHeaderBackground from "../../../img/prev_pubblico-NEUTRO.jpg";
import publicMobileHeaderBackground from '../../../img/prev_pubblico-mobile.jpg'
import privateMobileHeaderBackground from '../../../img/prev_privato-mobile.jpg'
import retiredMobileHeaderBackground from '../../../img/prev_pensionato-mobile.jpg'

const Subtitle = () => {
    return(
        <SubtitleText>
            Compila tutti i campi del form. <br/>
            Verrai ricontattato dai nostri consulenti per avere una proposta personalizzata.
        </SubtitleText>
    )
}
const ThankYouSection = () => {
    const [bgToShow, setBgToShow] = useState(defaultHeaderBackground)

    const [mobileBgToShow, setMobileBgToShow] = useState(defaultMobileHeaderBackground)

    useEffect(() => {
        const employeeType = JSON.parse(localStorage.getItem('selectData') || '[]')
            .find((data: any) => data.category === 'macroprofessione')

        if (employeeType?.value === 'Pubblico-Statale') {
            setBgToShow(publicHeaderBackground)
            setMobileBgToShow(publicMobileHeaderBackground)
        } else if (employeeType?.value === 'Privato') {
            setBgToShow(privateHeaderBackground)
            setMobileBgToShow(privateMobileHeaderBackground)
        } else if (employeeType?.value === 'Pensionato') {
            setBgToShow(retiredHeaderBackground)
            setMobileBgToShow(retiredMobileHeaderBackground)
        }
    }, [])

    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (ref.current) ref.current.focus();
        }, 100)
        return () => clearTimeout(timeout)
    }, []);

    return (
        <>
            <Header/>
            <PreventivatoreTitleSection backgroundUrl={`url(${bgToShow})`} mobileBackgroundUrl={`url(${mobileBgToShow})`} title={'PREVENTIVATORE'}>
                <Subtitle/>
            </PreventivatoreTitleSection>
            <Main>
                <Section>
                    <Container>
                        <div ref={ref} tabIndex={-1} role="status" aria-live={"polite"} style={{outline: 'none'}}>
                            <Img src={imgSource} alt={"Spunta Gialla"} aria-hidden="true"/>
                            <StyledH1>GRAZIE!</StyledH1>
                            <StyledP>
                                <strong>Verrai ricontattato dai nostri operatori secondo le modalità da te
                                    selezionate.</strong>
                            </StyledP>
                        </div>
                    </Container>
                </Section>
            </Main>
            <Footer/>
        </>
    )
}

const Main = styled.div`
    background-image: url(${bgUrl});
    opacity: 1;
    position: relative;
    max-width: 192rem;
    margin-left: auto;
    margin-right: auto;
    z-index: 5;
    display: block;
    transition: all 0.1s ease-out;
    background-position: center 22rem;
    background-repeat: no-repeat;
`

// region Style
const Section = styled.div`
    box-shadow: 0 10px 20px 0 rgb(0 0 0 / 70%);
    padding-top: 1rem;
    min-height: 16rem;
    background-color: rgba(34, 34, 34, 0.85);
    position: relative;
    max-width: 114rem;
    margin: 0 auto;
    z-index: 30;
    margin-top: -8rem;
    border-radius: 4.5rem;
    display: block;
`
const Container = styled.div`
    background-color: #FFF;
    border-radius: 4.5rem;
    height: 44rem;
    padding: 5rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Img = styled.img`
    margin-bottom: 1.5rem;
    width: 5rem;
    border-style: none;
    max-width: 100%;
`
const StyledH1 = styled(H1)`
    margin-bottom: 0.5em;
`
const StyledP = styled(P)`
    color: #767474;
    margin-bottom: 0;
`

const SubtitleText = styled.div`
  color: #242424;
`
// endregion

export default ThankYouSection
